const USERNAME = 'username'
const GROUP = 'group'
const AUTH_TOKEN = 'auth_token'
const EXPIRES_AT = 'expires_at'

export function isValidSession () {
  return [AUTH_TOKEN, EXPIRES_AT].every(
    item => localStorage.getItem(item) !== null
  ) && Date.now() < JSON.parse(localStorage.getItem(EXPIRES_AT))
}

export function setSession ({username, group, authToken, expiresIn}) {
  localStorage.setItem(USERNAME, username)
  localStorage.setItem(GROUP, group)
  localStorage.setItem(AUTH_TOKEN, authToken)
  localStorage.setItem(EXPIRES_AT, JSON.stringify(expiresIn * 1000 + Date.now()))
}

export function getSession () {
  return isValidSession()
    ? {
      username: localStorage.getItem(USERNAME),
      group: localStorage.getItem(GROUP),
      authToken: localStorage.getItem(AUTH_TOKEN),
      expiresAt: localStorage.getItem(EXPIRES_AT)
    }
    : null
}

export function clearSession () {
  [AUTH_TOKEN, EXPIRES_AT].forEach(item => {
    localStorage.removeItem(item)
  })
}



// WEBPACK FOOTER //
// ./src/utils/session.js